<template>
  <div>
    <div class="l-container">
      <div class="gallery">
        <h1 class="lower-title">WORKS</h1>
        <ul class="gallery-list">
          <li
            v-for="(img, index) in images"
            :key="index"
            class="gallery-list__item js-lazyload"
          >
            <a :href="img.src" target="_blank">
              <img :src="img.thumb" :alt="img.caption" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import galleryMixin from '../mixins/gallery';

export default {
  name: 'Works',
  data: function() {
    return {
      title: 'Works',
      description: '',
      images: [
        {
          thumb: 'images/works/works_thumb_001.jpg',
          src: 'pdf/2008-2012_WORKS.pdf',
          caption: 'Works 01',
        },
        {
          thumb: 'images/works/works_thumb_002.jpg',
          src: 'pdf/2015-2020_WORKS.pdf',
          caption: 'Works 02',
        },
      ],
    };
  },
  mixins: [galleryMixin],
  mounted() {
    const _lazyLoadTargets = document.querySelectorAll('.js-lazyload');
    this.setMeta(this.title, this.description);
    this.startUpLazyLoad(_lazyLoadTargets);
  },
};
</script>
